








import { defineComponent, PropType } from "@vue/composition-api";
import { Transaction } from "@scrile/api-provider/dist/api/TransactionProvider";
import TransactionView from "../TransactionView.vue";

export default defineComponent({
  name: "TransactionPaidMessage",
  components: { TransactionView },
  props: {
    transaction: { type: Object as PropType<Transaction>, required: true },
  },
});
